function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeFirstLayerModal, closeSecondLayerModal, closeThirdLayerModal, openFirstLayerModal, openSecondLayerModal, openThirdLayerModal, stopFirstLayerModalListening, stopSecondLayerModalListening, stopThirdLayerModalListening } from "../../../../redux/ui/modal/modalActions";
import { SECOND_LAYER_MODAL, THIRD_LAYER_MODAL } from "../../../../constants/modal";
export default (ChildComponent => {
  class ComposedComponent extends Component {
    constructor(...args) {
      super(...args);

      _defineProperty(this, "state", {
        modal: false
      });

      _defineProperty(this, "toggleModal", () => {
        this.setState(prevState => ({
          modal: !prevState.modal
        }), () => {
          if (this.props.modalLayer === THIRD_LAYER_MODAL) {
            this.state.modal ? this.props.openThirdLayerModal() : this.props.closeThirdLayerModal();
          } else if (this.props.modalLayer === SECOND_LAYER_MODAL) {
            this.state.modal ? this.props.openSecondLayerModal() : this.props.closeSecondLayerModal();
          } else {
            this.state.modal ? this.props.openFirstLayerModal() : this.props.closeFirstLayerModal();
          }
        });
      });

      _defineProperty(this, "componentDidUpdate", (prevProps, prevState, snapshot) => {
        if (this.props.modalLayer === THIRD_LAYER_MODAL) {
          if (this.props.thirdLayerModelListening && !this.props.thirdLayerModal && this.state.modal) {
            this.toggleModal();
            this.props.stopThirdLayerModalListening();
          }
        } else if (this.props.modalLayer === SECOND_LAYER_MODAL) {
          if (this.props.secondLayerModelListening && !this.props.secondLayerModal && this.state.modal) {
            this.toggleModal();
            this.props.stopSecondLayerModalListening();
          }
        } else {
          if (this.props.firstLayerModelListening && !this.props.firstLayerModal && this.state.modal) {
            this.toggleModal();
            this.props.stopFirstLayerModalListening();
          }
        }
      });

      _defineProperty(this, "componentWillUnmount", () => {
        if (this.state.modal) {
          this.toggleModal();
        }
      });

      _defineProperty(this, "render", () => {
        return /*#__PURE__*/React.createElement(ChildComponent, _extends({}, this.props, {
          modal: this.state.modal,
          toggleModal: this.toggleModal
        }));
      });
    }

  }

  function mapStateToProps(state) {
    return {
      firstLayerModal: state.ui.modal.firstLayer,
      firstLayerModelListening: state.ui.modal.firstLayerListening,
      secondLayerModal: state.ui.modal.secondLayer,
      secondLayerModelListening: state.ui.modal.secondLayerListening,
      thirdLayerModal: state.ui.modal.thirdLayer,
      thirdLayerModelListening: state.ui.modal.thirdLayerListening
    };
  }

  return connect(mapStateToProps, {
    openFirstLayerModal,
    closeFirstLayerModal,
    stopFirstLayerModalListening,
    openSecondLayerModal,
    closeSecondLayerModal,
    stopSecondLayerModalListening,
    openThirdLayerModal,
    closeThirdLayerModal,
    stopThirdLayerModalListening
  })(ComposedComponent);
});